import * as Yup from 'yup';
import { editProfileBirthdateValidationSchema } from '../../../../icsc-app/js/components/_molecules/EditProfileFieldsBirthdate';

export const getCommonSchema = ({
    isCaslConsentRequired,
    isGdprConsentRequired,
    isIndependent,
    isManualContactAddress,
    isNewCompany,
}) => {
    const validationShape = {
        ...editProfileBirthdateValidationSchema,
        birthdateDay: Yup.string().required('Birthdate Day is required'),
        birthdateMonth: Yup.string().required('Birthdate Month is required'),
        birthdateYear: Yup.string().required('Birthdate Year is required'),
        cellPhone: Yup.string().required('Mobile Phone is required'),
        independent: Yup.bool().required(),
        email: Yup.string().when('isPrimaryEmailRequired', {
            is: true,
            then: Yup.string()
                .email('Primary email must be a valid email')
                .required('Primary email is required'),
        }),
        firstName: Yup.string()
            .required('First Name is required')
            .min(2, 'First Name must be a miminum of 2 characters'),
        lastName: Yup.string()
            .required('Last Name is required')
            .min(2, 'Last Name must be a miminum of 2 characters'),
        isPrimaryEmailRequired: Yup.bool(),
        mainAddressAddress1: Yup.string().required('Address is required'),
        mainAddressAddress2: Yup.string(),
        mainAddressAddress3: Yup.string(),
        mainAddressCity: Yup.string().required('City is required'),
        mainAddressState: Yup.string().required('State/Province is required'),
        mainAddressCountry: Yup.string().required('Country is required'),
        mainAddressZip: Yup.string().required('Zip is required'),
        secondaryEmail: Yup.string().email('Secondary email must be a valid email'),
        workPhone: Yup.string().required('Work Phone is required'),
    };

    if (!isManualContactAddress) {
        validationShape.mainAddressFull = Yup.string().required('Address is required');
    }

    if (!isIndependent) {
        if (!isNewCompany) {
            validationShape.companyID = Yup.number()
                .required('Company is required')
                .nullable();
        }

        if (isNewCompany) {
            validationShape.newCompanyName = Yup.string().required('Company Name is required');
            validationShape.businessType = Yup.string().required('Business Type is required');
        }
    }

    if (!isIndependent) {
        validationShape.personalResponsibility = Yup.string().required('Responsibility is required');
        validationShape.title = Yup.string().required('Job Title is required');
    }

    if (isCaslConsentRequired) {
        validationShape.caslExpressConsent = Yup.bool()
            .nullable()
            .required('Contact permission is required');
    }

    if (isGdprConsentRequired) {
        validationShape.gdprConsent = Yup.bool()
            .nullable()
            .required('Contact permission is required');
    }

    return Yup.object().shape(validationShape);
};

export const newCompanySchema = ({ isManualCompanyAddress, hasSecondaryBusinessTypes }) => {
    const validationShape = {
        businessType: Yup.string().required('Business Type is required'),
        companyAddressAddress1: Yup.string().required('Company Address is required'),
        companyAddressAddress2: Yup.string(),
        companyAddressAddress3: Yup.string(),
        companyAddressCity: Yup.string().required('Company City is required'),
        companyAddressState: Yup.string().required('Company State/Province is required'),
        companyAddressCountry: Yup.string().required('Company Country is required'),
        companyAddressZip: Yup.string().required('Company Zip is required'),
        secondaryBusinessTypes: Yup.array(),
        minorityOwned: Yup.bool(),
        womanOwned: Yup.bool(),
        retailerAcknowledged: Yup.bool().when('businessType', {
            is: (businessType) => {
                console.log(businessType === 'RET');
                return businessType === 'RET'
            },
            then: Yup.bool().oneOf([true], 'Retailer Acknowledgement is required'),
        }),
    };

    if (hasSecondaryBusinessTypes) {
        validationShape.secondaryBusinessTypes = Yup.array().required('Company Secondary Business type is required');
    }

    if (!isManualCompanyAddress) {
        validationShape.companyAddressFull = Yup.string().required('Company Address is required');
    }

    return Yup.object().shape(validationShape);
};

export const defaultFormValues = {
    birthdateDay: '',
    birthdateMonth: '',
    birthdateYear: '',
    businessType: '',
    caslExpressConsent: null,
    cellPhone: '',
    companyID: null,
    companyName: '',
    confirmNewCompanyName: '',
    companyAddressFull: '',
    companyAddressAddress1: '',
    companyAddressAddress2: '',
    companyAddressAddress3: '',
    companyAddressCity: '',
    companyAddressState: '',
    companyAddressCountry: '',
    companyAddressZip: '',
    email: '',
    firstName: '',
    gdprConsent: null,
    independent: false,
    isPrimaryEmailRequired: false,
    lastName: '',
    mainAddressFull: '',
    mainAddressAddress1: '',
    mainAddressAddress2: '',
    mainAddressAddress3: '',
    mainAddressCity: '',
    mainAddressState: '',
    mainAddressCountry: '',
    mainAddressZip: '',
    minorityOwned: false,
    newCompanyName: '',
    personalResponsibility: '',
    retailerAcknowledged: false,
    secondaryEmail: '',
    smsUpdates: false,
    secondaryBusinessTypes: [],
    title: '',
    womanOwned: false,
    workPhone: '',
};

export const getUserFriendlyErrorMessage = errorMessage => {
    // TODO: What other messages need to be converted?
    switch (errorMessage) {
        case 'This email address is already in use':
            return 'Primary email address is already in use';
        default:
            return `An error has occurred. Please try again later, or if the problem persists, email us at membership@icsc.org.`;
    }
};

export const validateMinimumAge = ({ birthdateDay, birthdateMonth, birthdateYear }) => {
    const currentDate = new Date();

    const birthDate = new Date(parseInt(birthdateYear), parseInt(birthdateMonth - 1), parseInt(birthdateDay));

    let calculatedAge = currentDate.getFullYear() - birthDate.getFullYear();

    // Check if birthday has occurred this year
    if (
        currentDate.getMonth() < birthDate.getMonth() ||
        (currentDate.getMonth() === birthDate.getMonth() && currentDate.getDate() < birthDate.getDate())
    ) {
        calculatedAge -= 1;
    }

    if (calculatedAge < 16) {
        return false;
    }

    return true;
};
